import { useCallback, useEffect, useState } from "react";
import type { UseFolderAccordionArgs, UseFolderAccordionResult } from "./types";

export const useFolderAccordion = ({
  planRecords,
  selectedPlanRecordIndex,
}: UseFolderAccordionArgs): UseFolderAccordionResult => {
  const [openFolderId, setOpenFolderId] = useState<number | null>(null);

  const selectedPlan =
    selectedPlanRecordIndex === null
      ? undefined
      : planRecords[selectedPlanRecordIndex];

  const selectedPlanId = selectedPlan?.id ?? null;

  // An archived plan is not listed under the folders, so it opens none.
  const selectedPlanFolderId =
    selectedPlan === undefined || selectedPlan.archivedAt !== null
      ? null
      : selectedPlan.folderId;

  const toggleFolder = useCallback((folderId: number) => {
    setOpenFolderId((current) => (current === folderId ? null : folderId));
  }, []);

  // Keyed on the plan and its folder, not the index, so deleting another plan keeps the user's click
  useEffect(() => {
    setOpenFolderId(selectedPlanFolderId);
  }, [selectedPlanId, selectedPlanFolderId]);

  return {
    openFolderId,
    toggleFolder,
    isSelectedPlanFolderOpen:
      selectedPlanFolderId === null || openFolderId === selectedPlanFolderId,
  };
};
